var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.837,
    height: 21.963,
    viewBox: "0 0 24.837 21.963",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.837,
    height: 21.963,
    fill: "#595959"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.054,7.908l9.512-5.8,9.513,5.851,1.326-.939a1.273,1.273,0,0,0-.04-2.105L20.414.376a1.273,1.273,0,0,0-1.3-.053L16.325,1.831,14.167.22A1.108,1.108,0,0,0,12.9.176L5.535,4.915a1.108,1.108,0,0,0-.06,1.823Z",
    transform: "translate(-4.401 0)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.511,69.018a1.238,1.238,0,0,1-.685-.207l-.012-.008-3.019-2.186L107.9,60.2l1.953,1.152a1.241,1.241,0,0,1,.077,2.088l-7.711,5.354a1.237,1.237,0,0,1-.707.223m-.29-.792a.533.533,0,0,0,.595-.01l7.711-5.354a.535.535,0,0,0-.033-.9l-1.581-.933-8.861,5.626Z",
    transform: "translate(-85.625 -52.709)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.221,68.678a1.218,1.218,0,0,1-.64-.18l-.016-.011-7-4.871A1.215,1.215,0,0,1,.511,61.6l2.142-1.525L11.9,66.579,8.772,68.546a1.214,1.214,0,0,1-.551.131M7.96,67.9a.512.512,0,0,0,.48.022l2.192-1.378L2.655,60.937.92,62.173a.509.509,0,0,0,.028.848l.016.011Z",
    transform: "translate(-0.001 -52.597)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.319,63.545,29.934,69.6l-2.656,1.669a.862.862,0,0,1-.845-.035l-5.113-3.559v4.07L30.577,77.6V69.589Z",
    transform: "translate(-18.666 -55.637)",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.613,71.771a.888.888,0,0,1-1,.011l-2.6-1.881,8.88-5.638v-.332l-9.565,6v7.995l9.565-5.741V68.1Z",
    transform: "translate(-85.221 -55.975)",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.e8883fa053f1ab148b89081089b6fb4e.svg";
export { ForwardRef as ReactComponent };